import Cookies from 'js-cookie';

(function ( $ ) {
	'use strict';

	var billingCountrySelected = null;
	var shippingCountrySelected = null;
	var requiredHtmlPointer = '<abbr class="required" title="verplicht">*</abbr>';
	var dutchCustomersIndex = 'NL';
	var belgiumCustomersIndex = 'BE';
	var belgiumPostcodeMask = '0000';
	var dutchPostcodeMask = '0000AA';
	var belgiumPostcodePlaceholder = '1234';
	var dutchPostcodePlaceholder = '1234AA';


	$(document.body).on('checkout_error', function(event, error_message) {
		$(error_message).find("li").each(function(index) {
			let field_name = $(this).data("id");
			let message = $.trim($(this).text());

			pushErrorDatalayer(field_name, message);
		});
	});

	// push error messages to the datalayer
	function pushErrorDatalayer(field_name, message) {
		window.dataLayer = window.dataLayer || [];
		window.didomiOnReady = window.didomiOnReady || [];
        window.didomiOnReady.push(function (Didomi) {
			window.dataLayer.push({
				'event': 'tracked_error',
				'error_type': 'checkout_error', // Vaste parameter
				'error_field': field_name,
				'error_message' : message //hier moet de inhoudelijke foutmelding komen
			});
		});
	}

	function add_bargain_to_cart_event() {
		$( '.woocommerce-cart' ).on( 'click', 'input[data-action="add-bargain-to-cart"]', function(e) {
			
			$( this ).closest( 'div.add-to-cart' ).html( '<img src="' + WPGShop.loadingGifUrl + '" alt="Loading" />' );

			$.ajax( {
				url      : WPGShop.ajaxUrl,
				type     : 'POST',
				dataType : 'json',
				data     : {
					action    : 'wpg_shop_add_bargain_to_cart',
					productID : $( this ).data( 'productId' ),
				}
			} ).done( function ( response, textStatus, jqXHR ) {
				if ( true === jqXHR.responseJSON.success ) {

					if (typeof window.add_to_cart_bargain_gtm_event === "function") { 
						window.add_to_cart_bargain_gtm_event(response.data);
					}

					location.reload();
				}
			} );
		} );
	}

	add_bargain_to_cart_event();

	function hide_checkoutbargain() {
		var shippingCost = $( "[data-hap-cart-shipping-cost]" ).data( "hap-cart-shipping-cost" )
		var total = $( "[data-hap-cart-total]").data( "hap-cart-total" ) - shippingCost;
		var min_price = $( '.kassakoopje[data-bargain_min_price]' ).data( 'bargain_min_price' );

		if( total === "" || min_price === "" ) {
			return false;
		}

		if( total <= min_price ) {
			$( ".kassakoopje .add-to-cart" ).addClass( "hide" );
		} else {
			$( ".kassakoopje .add-to-cart" ).removeClass( "hide" );
		}
	}

	if( $( '.kassakoopje[data-bargain_min_price]' ).length ) {
		hide_checkoutbargain();
	}

	$( 'body' ).on( 'updated_cart_totals' , function( e, data ) {
		hide_checkoutbargain();
		add_bargain_to_cart_event();
		wpg_shop_cart_onpageload();
	});

	$( 'body' ).on( 'removed_coupon', function( e, data ) {
		add_bargain_to_cart_event();
	} );

	$( 'body' ).on( 'updated_wc_div', function( e, data ) {
		add_bargain_to_cart_event();
	} );

	if ( $( 'div.out-of-stock' ).length > 0 ) {
		$.ajax( {
			url: WPGShop.ajaxUrl,
			type: 'POST',
			data: {
				action: 'wpg_shop_fetch_email_stock_notification_form'
			},
			dataType: 'JSON'
		} ).done( function( data, textStatus, jqXHR ) {
			$('div.out-of-stock').html( jqXHR.responseJSON.data.formHTML );

			if( !$('div.out-of-stock-notice').length ) {
				$('div.out-of-stock').append( '<div class="out-of-stock-notice"></div>' );
			}

			$( 'body' ).trigger( 'subscribe_availability_loaded' );
		} );
	}


	function wpg_shop_cart_onpageload() {

		// // toggle Kassakoopje
		if( $( '.show_kassakoopje' ).length > 0 ) {
			$( '.kassakoopje' ).removeClass( 'hidden' );
		}
	}

	wpg_shop_cart_onpageload();

	$( 'form.woocommerce-checkout input#billing_postcode, form.woocommerce-checkout input#shipping_postcode' ).mask( dutchPostcodeMask );

	$( 'form.woocommerce-checkout .readonly input' ).attr( 'readonly', 'readonly' );

	$( document.body ).on( {
		updated_checkout : function () {
			//Always show NAW Form
			$( '.wpg_billing_container' ).show();
			// Break when there is a error.
			if ( jQuery( '.woocommerce-error' ).length > 0 ) {
				return;
			}

			$( '.payment_methods li' ).each( function () {
				if( $( this ).hasClass( 'payment_method_' ) ) {
					$( this ).remove();
					return;
				}

				if ( '0' !== $( this ).attr( 'data-maximum_amount' ) &&
					parseFloat( $( this ).attr( 'data-maximum_amount' ) ) < parseFloat( WPGShop.cartTotal ) ) {
					$( this ).hide().find( 'input' ).prop("checked", false);
				}
			} );
		}
	} );

	$( document ).on( {
		submit : function ( e ) {
			e.preventDefault();
			e.returnValue = false;

			$.SubscribeAvailability( $( this ).find( 'input#email' ).val() );
		}
	}, 'form#SubscribeAvailability' );

	$.SubscribeAvailability = function ( email ) {
		var variation_id = 0;
		if ( $( 'input[name="variation_id"]' ).length > 0 ) {
			variation_id = $( 'input[name="variation_id"]' ).val();
		}

		$.ajax( {
			url      : WPGShop.ajaxUrl,
			data     : {
				email       : email,
				action      : 'wpg_shop_subscribe_availability',
				productId   : WPGShop.productId,
				variationId : variation_id
			},
			type     : 'POST',
			dataType : 'JSON'
		} ).done( function ( obj ) {
			if ( obj.success ) {
				$( '.out-of-stock-notice' ).html( '<div class="SubscribeAvailability_response">' + obj.data.message + '</div>' );
			} else {
				$( '.out-of-stock-notice' ).html( '<div class="SubscribeAvailability_response">' + obj.data.error + '</div>' );
			}
		} );
	};

	$( document.body ).on( 'click', 'a.showBilling', function() {
		$( '.wpg_billing_container' ).slideToggle();
		$( '.woocommerce_um_login' ).hide( 200 );
		return false;
	});

	$( document.body ).on( 'click', 'a.showlogin', function() {
		$( '.wpg_billing_container' ).hide( 200 );
		return false;
	});


	$(function() {
		toggleBillingFields($('#billing_country').val());
	});

	$('#billing_country').on('change', function (e) {
		e.preventDefault();
		toggleBillingFields($(this).val());
	});

	$('#shipping_country').on('change',function (e) {
		e.preventDefault();
		toggleShippingFields($(this).val());
	});

	$('#ship-to-different-address-checkbox').on('change', function(e){
		e.preventDefault();
		toggleShippingFields($('#shipping_country').val());
	});

	function toggleBillingFields(countrySelected) {
		$( document.body ).trigger( 'update_checkout' );

		billingCountrySelected            = countrySelected;
		var billingHouseNumberSuffixField = $( '#billing_housenumber_suffix_field' );
		var billingPostcode               = $( 'form.woocommerce-checkout input#billing_postcode' );
		var billingBirthDate              = $( 'form.woocommerce-checkout input#billing_date_of_birth' );

		billingPostcode.attr( 'placeholder', '' );

		if ( billingCountrySelected === dutchCustomersIndex ) {
			billingPostcode.mask( dutchPostcodeMask ).attr( 'placeholder', dutchPostcodePlaceholder );
		} else {
			billingPostcode.mask( belgiumPostcodeMask ).attr( 'placeholder', belgiumPostcodePlaceholder );

			if(billingCountrySelected === belgiumCustomersIndex) {
				billingHouseNumberSuffixField.show();
			} else {
				billingHouseNumberSuffixField.hide();
			}
		}

		if (billingCountrySelected === dutchCustomersIndex || billingCountrySelected === belgiumCustomersIndex) {
			billingBirthDate.mask( '00-00-0000' );
			billingBirthDate.attr( 'placeholder', 'dd-mm-yyyy' );
		} else {
			billingBirthDate.mask( '0000-00-00' );
			billingBirthDate.attr( 'placeholder', 'yyyy-mm-dd' );
		}
	}

	function toggleShippingFields(countrySelected) {
		shippingCountrySelected = countrySelected;
		var shippingHouseNumberSuffixField = $('#shipping_housenumber_suffix_field');
		var shippingPostcode = $('form.woocommerce-checkout input#shipping_postcode');
		var shippingBirthDate = $( 'form.woocommerce-checkout input#shipping_date_of_birth' );

		shippingPostcode.attr('placeholder', '');

		if (shippingCountrySelected === dutchCustomersIndex) {
			shippingPostcode.mask(dutchPostcodeMask).attr('placeholder', dutchPostcodePlaceholder);
		} else {
			shippingPostcode.mask(belgiumPostcodeMask).attr('placeholder', belgiumPostcodePlaceholder);

			if(shippingCountrySelected === belgiumCustomersIndex) {
				shippingHouseNumberSuffixField.show();
			} else {
				shippingHouseNumberSuffixField.hide();
			}
		}

		if (shippingCountrySelected === dutchCustomersIndex || shippingCountrySelected === belgiumCustomersIndex) {
			shippingBirthDate.mask( '00-00-0000' );
			shippingBirthDate.attr( 'placeholder', 'dd-mm-yyyy' );
		} else {
			shippingBirthDate.mask( '0000-00-00' );
			shippingBirthDate.attr( 'placeholder', 'yyyy-mm-dd' );
		}
	}
} )( jQuery );
